<template>
	<div
		class="flex py-4 duration-75 border-b last:border-b-0"
		:class="readClasses"
	>
		<div class="flex justify-center flex-none w-6">
			<AppIcon
				v-if="!read"
				name="fiber_manual_record"
				class="mt-1.5 text-sm text-accent-primary"
			/>
		</div>
		<div class="w-full pr-6">
			<slot />
		</div>
	</div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

interface Props {
	read: boolean;
}
const props = defineProps<Props>();
const readClasses = computed(() => ({
	"bg-purple-50 transition cursor-pointer hover:bg-purple-100": !props.read,
}));
</script>
